import React from 'react';
import { css } from 'glamor';
import * as theme from '../theme';
const color = theme.flavours.danger.highlightColor;

export const InlineError = ({ error }) => {
	return <span className={css({ color })}>{error}</span>;
};
